import React from 'react';
import { useText, useLink } from 'common/hooks';
import { Wrapper, Text, Button } from './elements';

export default function DeleteEverything(): React.ReactElement {
  const t = useText();
  const link = useLink();

  return (
    <Wrapper>
      <Text>{t('account.settings.profile.general_info.delete_account')}</Text>
      <Button href={link('profile/delete')}>
        {t('account.settings.profile.general_info.delete_everything')}
      </Button>
    </Wrapper>
  );
}
